import axios from '@axios'

// Carga en segundo plano las imagenes de un listado de materiales pedido con
// GET /materiales?sinImg=1. Va por lotes para que la tabla se pinte al instante
// y las fotos aparezcan poco a poco. Devuelve una promesa que resuelve al acabar.
//
// Los objetos deben tener ya la clave `img` (aunque sea '') para que Vue 2 la
// trate como reactiva; `prepararSinImagen` se encarga de eso.
export function prepararSinImagen(lista) {
  (lista || []).forEach(m => {
    if (m.img === undefined) m.img = ''
  })
  return lista
}

export async function cargarImagenesMateriales(lista, opciones = {}) {
  const tamLote = opciones.tamLote || 10
  const pendientes = (lista || []).filter(m => !m.img)
  const porId = {}
  pendientes.forEach(m => { porId[m.id] = m })
  const ids = Object.keys(porId)

  for (let i = 0; i < ids.length; i += tamLote) {
    const lote = ids.slice(i, i + tamLote)
    try {
      const { data } = await axios.get('/materiales/imagenes', { params: { ids: lote.join(',') }, silencioso: true })
      const filas = data || []
      filas.forEach(d => {
        const m = porId[d.id]
        if (m && d.img) m.img = d.img
      })
    } catch (e) {
      // Si falla un lote seguimos con el siguiente: la tabla ya es usable sin fotos.
      console.error('Error cargando imagenes de materiales:', e)
    }
  }
}
